import { Pipe, PipeTransform } from '@angular/core';
import { ResourceDeploymentState } from '../services/GI.Web.Services.g';

@Pipe({ name: 'resourceDeploymentStateToString' })
export class ResourceDeploymentStateToStringPipe implements PipeTransform {
    transform(value: ResourceDeploymentState): string {
        // HACK: Change Running to Deploying to make it more clear for the user. Evaluations does this a different way. :-/
        if (value === ResourceDeploymentState.Running) {
            return 'Deploying';
        }
        if (value === ResourceDeploymentState.NotSpecified) {
            return 'Not Specified';
        }
        // Using built-in feature of TypeScript enums to return string via indexer
        return ResourceDeploymentState[value];
    }
}



// WEBPACK FOOTER //
// ./src/app/pipes/resourceDeploymentStatePipe.ts